import React, { createContext, useContext, useState } from 'react';
import { fetchPostWithTableData } from '@/Components/hooks/Api';

const CaseManagementContext = createContext();

export const CaseManagementProvider = ({ children }) => {
  const [caseManagementCounts, setCaseManagementCounts] = useState({});

  const getCaseManagementCounts = (AgencyID, IncidentID, CaseID) => {
    fetchPostWithTableData('CaseManagement/CaseManagement_Get_Counts', {
      AgencyID,
      IncidentID,
      CaseID,
    }).then((data) => {
      if (data) {
        setCaseManagementCounts({
          Entities: data?.Table?.[0]?.Entities ?? 0,
          CaseTeam: data?.Table1?.[0]?.CaseTeam ?? 0,
          CaseEffort: data?.Table2?.[0]?.CaseEffort ?? 0,
          DetectiveNotes: data?.Table3?.[0]?.DetectiveNotes ?? 0,
          PropertyRoom: data?.Table4?.[0]?.PropertyRoom ?? 0,
          CaseReport: data?.Table6?.[0]?.CaseReport ?? 0,
        });
      } else {
        setCaseManagementCounts({});
      }
    });
  };

  return (
    <CaseManagementContext.Provider
      value={{
        caseManagementCounts,
        setCaseManagementCounts,
        getCaseManagementCounts,
      }}
    >
      {children}
    </CaseManagementContext.Provider>
  );
};

export const useCaseManagement = () => {
  const context = useContext(CaseManagementContext);
  if (!context) throw new Error('useCaseManagement must be used within CaseManagementProvider');
  return context;
};

export default CaseManagementContext;
